// @ts-check
/** @type {DischargeQuestionBaseEntry[]} */
export const ALDRETE_FIELDS = [
  {
    label: 'Oxygenation',
    name: 'aldreteOxygenation',
    options: [
      ['SpO2 > 92% on room air', 2],
      ['SpO2 > 90% on oxygen', 1],
      ['SpO2 < 90% on oxygen', 0],
    ],
  },
  {
    label: 'Respiratory Stability',
    name: 'aldreteRespiratoryStability',
    options: [
      ['Breathes deeply and coughs freely', 2],
      ['Dyspnoeic, shallow or limited breathing', 1],
      ['Apnea', 0],
    ],
  },
  {
    label: 'Consciousness',
    name: 'aldreteConsciousness',
    options: [
      ['Awake and oriented', 2],
      ['Arousable with minimal stimulation', 1],
      ['Responsive only to tactile stimulation', 0],
    ],
  },
  {
    label: 'Post Operative Pain',
    name: 'aldretePain',
    options: [
      ['Minimal to no pain', 2],
      ['Moderate', 1],
      ['Persistent severe pain', 0],
    ],
  },
  {
    label: 'Nausea and Vomiting',
    name: 'aldreteNausea',
    options: [
      ['None to minimal', 2],
      ['Moderate', 1],
      ['Severe', 0],
    ],
  },
  {
    label: 'Gait',
    name: 'aldreteGait',
    options: [
      ['Steady w/o dizziness', 2],
      ['Requires assistance', 1],
      ['Unable to ambulate', 0],
    ],
  },
]

/** @type {DischargeQuestionBaseEntry[]} */
export const PADS_FIELDS = [
  {
    label: 'Patient is oriented',
    name: 'oriented',
    isBoolean: true,
    options: [
      ['oriented', 1],
      ['not oriented', 0],
    ],
  },
  {
    label: 'Patient has steady gait',
    name: 'steadyGait',
    isBoolean: true,
    options: [
      ['steady gait', 1],
      ['not steady gait', 0],
    ],
  },
  {
    label: 'Patient voided',
    name: 'voided',
    isBoolean: true,
    options: [
      ['voided', 1],
      ['not voided', 0],
    ],
  },
  {
    label: 'Patient drank',
    name: 'poFluids',
    isBoolean: true,
    options: [
      ['PO fluids', 1],
      ['no PO fluids', 0],
    ],
  },
  {
    label: 'Surgical bleeding',
    name: 'surgicalBleeding',
    options: [
      ['Minimal', 2],
      ['Moderate', 1],
      ['Severe', 0],
    ],
  },
  {
    label: 'Pain, nausea and/or vomiting',
    name: 'painNauseaVomiting',
    options: [
      ['Minimal', 2],
      ['Moderate', 1],
      ['Severe', 0],
    ],
  },
]
